import React from "react";
import GameTracker from "./GameTracker";

const Test = () => {
  return (
    <div>
      <h2>Live Game Tracker</h2>
      <GameTracker fixtureId="12345" productName="football" />
    </div>
  );
};

export default Test;
